import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "narrow-view" }

import { onBeforeMount } from 'vue'

import FormButton from '@/components/common/FormButton.vue'
import FormButtonGroup from '@/components/common/FormButtonGroup.vue'
import RouterLinkButton from '@/components/common/RouterLinkButton.vue'
import { useAuthStore } from '@/store/bowler-app/auth'
import { useBowlerStore } from '@/store/bowler-app/bowler'
import { useUserStore } from '@/store/bowler-app/user'


export default /*@__PURE__*/_defineComponent({
  __name: 'LogoutView',
  setup(__props) {

const homepageUrl: string =
  process.env.VUE_APP_HOMEPAGE_URL ?? 'https://keilailu.fi/'

const navigateToHomepage = (): string => (window.location.href = homepageUrl)

onBeforeMount((): void => {
  useBowlerStore().clear()
  useUserStore().clear()
  useAuthStore().logout()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('general.farewell')), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('general.logout-confirmation')), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('general.next-action-question')), 1),
    _createVNode(FormButtonGroup, null, {
      default: _withCtx(() => [
        _createVNode(RouterLinkButton, { to: { path: '/login' } }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('general.login-again')), 1)
          ]),
          _: 1
        }),
        _createVNode(FormButton, { onClick: navigateToHomepage }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('general.to-homepage')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})